import { computePosition, offset, flip, shift, arrow, autoUpdate } from '@floating-ui/dom'
import { htmlToElement } from './htmlUtils'

const storage = new WeakMap()

const BASE_CLASSES = {
  tooltip: 'tooltip',
  popover: 'popover'
}

const SHOW_EVENTS = ['mouseenter', 'focus']
const HIDE_EVENTS = ['mouseleave', 'blur']

export default function initializeTooltip(button) {
  if (storage.has(button)) {
    return
  }

  const baseClass = BASE_CLASSES[button.dataset.toggle] || BASE_CLASSES.tooltip
  const content = button.dataset.tooltipTitle || button.title
  const tooltip = htmlToElement(`
    <div class="${baseClass}" role="tooltip" style="position: absolute; top: 0; left: 0;">
      <div class="tooltip__arrow"></div>
      ${content}
    </div>
  `)

  button.append(tooltip)
  button.title = ''

  const arrowElement = tooltip.querySelector('.tooltip__arrow')

  function updatePosition() {
    computePosition(button, tooltip, {
      placement: button.dataset.popperPlacement || 'bottom',
      middleware: [
        offset(8),
        flip(),
        shift({ padding: 5 }),
        arrow({ element: arrowElement })
      ]
    }).then(({ x, y, placement, middlewareData }) => {
      Object.assign(tooltip.style, {
        left: `${x}px`,
        top: `${y}px`
      })

      if (middlewareData.arrow) {
        const { x: arrowX, y: arrowY } = middlewareData.arrow
        Object.assign(arrowElement.style, {
          left: arrowX != null ? `${arrowX}px` : '',
          top: arrowY != null ? `${arrowY}px` : ''
        })
      }

      tooltip.setAttribute('data-placement', placement)
    })
  }

  function show() {
    tooltip.setAttribute('data-show', '')

    if (entry.cleanup) {
      entry.cleanup()
    }

    entry.cleanup = autoUpdate(button, tooltip, updatePosition)
  }

  function hide() {
    tooltip.removeAttribute('data-show')

    if (entry.cleanup) {
      entry.cleanup()
      entry.cleanup = null
    }
  }

  const entry = { tooltip, cleanup: null, show, hide }
  storage.set(button, entry)

  SHOW_EVENTS.forEach(event => {
    button.addEventListener(event, show)
  })

  HIDE_EVENTS.forEach(event => {
    button.addEventListener(event, hide)
  })
}

export function destroyTooltip(button) {
  const entry = storage.get(button)
  if (!entry) {
    return
  }

  if (entry.cleanup) {
    entry.cleanup()
  }

  SHOW_EVENTS.forEach(event => {
    button.removeEventListener(event, entry.show)
  })

  HIDE_EVENTS.forEach(event => {
    button.removeEventListener(event, entry.hide)
  })

  entry.tooltip.remove()
  storage.delete(button)
}
